class CustomerSurvey {
  constructor() {
    this.customerEmail = null;
    this.customerPhone = null;
    this.customerName = null;
    this.floatingButton = null;
    this.modal = null;
    this.overlay = null;
    this.isLoggedIn = false;
    this.hasCompletedSurvey = false;
    
    this.init();
  }

  init() {
    // Check if user is logged in - use the same approach as lifestyle preferences
    this.isLoggedIn = window.lifestylePreferences?.isLoggedIn || document.querySelector('.customer-logged-in') !== null;
    
    if (this.isLoggedIn) {
      // Get customer email from the same global object as lifestyle preferences
      this.customerEmail = window.lifestylePreferences?.customerEmail || '';
      this.customerName = document.querySelector('[data-customer-name]')?.getAttribute('data-customer-name') || '';
      this.customerPhone = document.querySelector('[data-customer-phone]')?.getAttribute('data-customer-phone') || '';
      
      // Check if user has already completed a survey
      if (this.customerEmail) {
        this.checkExistingSurvey()
          .then(exists => {
            this.hasCompletedSurvey = exists;
            
            // Only show the survey button if they haven't completed it yet
            if (!this.hasCompletedSurvey) {
              this.createFloatingButton();
              this.createModal();
              this.bindEvents();
            }
          })
          .catch(error => {
            console.error('Error checking survey status:', error);
            // If there's an error checking, show the survey anyway
            this.createFloatingButton();
            this.createModal();
            this.bindEvents();
          });
      } else {
        // If we can't get the email, show the survey anyway
        this.createFloatingButton();
        this.createModal();
        this.bindEvents();
      }
    }
  }

  createFloatingButton() {
    this.floatingButton = document.createElement('div');
    this.floatingButton.className = 'survey-floating-button';
    this.floatingButton.innerHTML = '<i class="fa fa-comment"></i>';
    document.body.appendChild(this.floatingButton);
  }

  createModal() {
    // Create overlay
    this.overlay = document.createElement('div');
    this.overlay.className = 'survey-overlay';
    
    // Create modal
    this.modal = document.createElement('div');
    this.modal.className = 'survey-modal';
    
    // Create modal content
    this.modal.innerHTML = `
      <div class="survey-modal-content">
        <div class="survey-modal-header">
          <h2>LivGood Customer Feedback Survey</h2>
          <button class="survey-close-button">&times;</button>
        </div>
        
        <div class="survey-modal-body">
          <p class="survey-intro">
            Thank you for being a valued LivGood customer. Please take 2 minutes to complete this short survey. 
            Your feedback helps us serve you better — and as a thank-you, you'll receive a free delivery voucher upon completion!
          </p>
          
          <form id="customer-survey-form">
            <div class="survey-question">
              <label>How satisfied are you with your overall experience with LivGood?</label>
              <div class="rating-scale">
                <div class="rating-labels">
                  <span>Very dissatisfied</span>
                  <span>Very satisfied</span>
                </div>
                <div class="rating-buttons" data-rating-field="overallExperience">
                  <button type="button" data-value="1">1</button>
                  <button type="button" data-value="2">2</button>
                  <button type="button" data-value="3" class="selected">3</button>
                  <button type="button" data-value="4">4</button>
                  <button type="button" data-value="5">5</button>
                </div>
              </div>
            </div>
            
            <div class="survey-question">
              <label>How would you rate the quality of the products you receive?</label>
              <div class="rating-scale">
                <div class="rating-labels">
                  <span>Very poor</span>
                  <span>Excellent</span>
                </div>
                <div class="rating-buttons" data-rating-field="productQuality">
                  <button type="button" data-value="1">1</button>
                  <button type="button" data-value="2">2</button>
                  <button type="button" data-value="3" class="selected">3</button>
                  <button type="button" data-value="4">4</button>
                  <button type="button" data-value="5">5</button>
                </div>
              </div>
            </div>
            
            <div class="survey-question">
              <label>How would you rate the freshness of the groceries delivered?</label>
              <div class="rating-scale">
                <div class="rating-labels">
                  <span>Never fresh</span>
                  <span>Always fresh</span>
                </div>
                <div class="rating-buttons" data-rating-field="freshness">
                  <button type="button" data-value="1">1</button>
                  <button type="button" data-value="2">2</button>
                  <button type="button" data-value="3" class="selected">3</button>
                  <button type="button" data-value="4">4</button>
                  <button type="button" data-value="5">5</button>
                </div>
              </div>
            </div>
            
            <div class="survey-question">
              <label>How satisfied are you with our delivery time and punctuality?</label>
              <div class="rating-scale">
                <div class="rating-labels">
                  <span>Very dissatisfied</span>
                  <span>Very satisfied</span>
                </div>
                <div class="rating-buttons" data-rating-field="deliveryTime">
                  <button type="button" data-value="1">1</button>
                  <button type="button" data-value="2">2</button>
                  <button type="button" data-value="3" class="selected">3</button>
                  <button type="button" data-value="4">4</button>
                  <button type="button" data-value="5">5</button>
                </div>
              </div>
            </div>
            
            <div class="survey-question">
              <label>Have you experienced any issues with your orders in the past 3 months?</label>
              <div class="radio-options">
                <label class="radio-label">
                  <input type="radio" name="hadIssues" value="true"> Yes (please describe in the next question)
                </label>
                <label class="radio-label">
                  <input type="radio" name="hadIssues" value="false" checked> No
                </label>
              </div>
            </div>
            
            <div class="survey-question">
              <label>(Optional) Please describe any issue(s) you've had and how we handled them:</label>
              <textarea name="issueDescription" rows="3" placeholder="Your answer here..."></textarea>
            </div>
            
            <div class="survey-question">
              <label>How easy is it to use the LivGood app/website for ordering?</label>
              <div class="rating-scale">
                <div class="rating-labels">
                  <span>Very difficult</span>
                  <span>Very easy</span>
                </div>
                <div class="rating-buttons" data-rating-field="easeOfUse">
                  <button type="button" data-value="1">1</button>
                  <button type="button" data-value="2">2</button>
                  <button type="button" data-value="3" class="selected">3</button>
                  <button type="button" data-value="4">4</button>
                  <button type="button" data-value="5">5</button>
                </div>
              </div>
            </div>
            
            <div class="survey-question">
              <label>What would you like us to improve or add to our service?</label>
              <textarea name="improvementSuggestions" rows="3" placeholder="Your answer here..."></textarea>
            </div>
            
            <div class="survey-question">
              <label>Would you recommend LivGood to your friends or family?</label>
              <div class="rating-scale">
                <div class="rating-labels">
                  <span>Definitely not</span>
                  <span>Definitely</span>
                </div>
                <div class="rating-buttons" data-rating-field="recommendation">
                  <button type="button" data-value="1">1</button>
                  <button type="button" data-value="2">2</button>
                  <button type="button" data-value="3" class="selected">3</button>
                  <button type="button" data-value="4">4</button>
                  <button type="button" data-value="5">5</button>
                </div>
              </div>
            </div>
            
            <div class="survey-question">
              <label>Any other feedback, suggestions, or comments?</label>
              <textarea name="otherFeedback" rows="3" placeholder="Your answer here..."></textarea>
            </div>
            
            <div class="survey-submit">
              <button type="submit" class="survey-submit-button">Submit Feedback</button>
            </div>
          </form>
        </div>
      </div>
    `;
    
    // Append modal and overlay to body
    document.body.appendChild(this.overlay);
    document.body.appendChild(this.modal);
  }

  bindEvents() {
    // Open modal when floating button is clicked
    this.floatingButton.addEventListener('click', () => {
      this.openModal();
    });
    
    // Close modal when close button is clicked
    this.modal.querySelector('.survey-close-button').addEventListener('click', () => {
      this.closeModal();
    });
    
    // Close modal when overlay is clicked
    this.overlay.addEventListener('click', () => {
      this.closeModal();
    });
    
    // Handle rating button clicks
    const ratingGroups = this.modal.querySelectorAll('.rating-buttons');
    ratingGroups.forEach(group => {
      const buttons = group.querySelectorAll('button');
      buttons.forEach(button => {
        button.addEventListener('click', () => {
          // Remove selected class from all buttons in this group
          buttons.forEach(btn => btn.classList.remove('selected'));
          // Add selected class to clicked button
          button.classList.add('selected');
        });
      });
    });
    
    // Handle form submission
    const form = this.modal.querySelector('#customer-survey-form');
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.submitSurvey();
    });
  }

  openModal() {
    this.modal.style.display = 'block';
    this.overlay.style.display = 'block';
    document.body.style.overflow = 'hidden'; // Prevent scrolling
  }

  closeModal() {
    this.modal.style.display = 'none';
    this.overlay.style.display = 'none';
    document.body.style.overflow = ''; // Re-enable scrolling
  }

  getRatingValues() {
    const ratings = {};
    const ratingGroups = this.modal.querySelectorAll('.rating-buttons');
    
    ratingGroups.forEach(group => {
      const field = group.getAttribute('data-rating-field');
      const selectedButton = group.querySelector('.selected');
      if (selectedButton) {
        ratings[field] = parseInt(selectedButton.getAttribute('data-value'));
      }
    });
    
    return ratings;
  }

  checkExistingSurvey() {
    return new Promise((resolve, reject) => {
      if (!this.customerEmail) {
        resolve(false);
        return;
      }
      
      console.log('Checking survey existence for email:', this.customerEmail);
      
      // Use the API endpoint from the Flutter app
      fetch('https://livgood-pt.herokuapp.com/api/v2/survey/exisit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          email: this.customerEmail
        })
      })
      .then(response => {
        // Check if the response was successful first
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        console.log('Survey existence check response:', data);
        
        // The API returns a direct boolean value
        if (typeof data === 'boolean') {
          console.log('API returned boolean:', data);
          resolve(data); // true means survey exists, false means it doesn't
        } 
        // Or it might return an object with exists property
        else if (data && typeof data.exists === 'boolean') {
          console.log('API returned object with exists property:', data.exists);
          resolve(data.exists);
        } 
        // Handle any other response format
        else {
          console.warn('Unexpected API response format:', data);
          resolve(false); // Default to showing the survey if response format is unexpected
        }
      })
      .catch(error => {
        console.error('Error checking survey existence:', error);
        // If there's an error, assume they haven't completed it
        resolve(false);
      });
    });
  }

  submitSurvey() {
    const form = this.modal.querySelector('#customer-survey-form');
    const formData = new FormData(form);
    
    // Get rating values
    const ratings = this.getRatingValues();
    
    // Combine form data and ratings to match the Flutter app's API structure
    const surveyData = {
      email: this.customerEmail,
      phone: this.customerPhone || '',
      overallExperience: ratings.overallExperience || 3,
      productQuality: ratings.productQuality || 3,
      freshness: ratings.freshness || 3,
      deliveryTime: ratings.deliveryTime || 3,
      hadIssues: formData.get('hadIssues') === 'true',
      issueDescription: formData.get('issueDescription') || '',
      easeOfUse: ratings.easeOfUse || 3,
      improvementSuggestions: formData.get('improvementSuggestions') || '',
      recommendation: ratings.recommendation || 3,
      otherFeedback: formData.get('otherFeedback') || ''
    };
    
    console.log('Survey data to submit:', surveyData);
    
    // Send data to backend API using the endpoint from the Flutter app
    fetch('https://livgood-pt.herokuapp.com/api/v2/survey', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(surveyData)
    })
    .then(response => {
      // Check if the HTTP response was successful
      if (!response.ok) {
        // If we got a response but with error status code
        return response.json().then(errorData => {
          // Throw an error with the API's error message if available
          throw new Error(errorData.message || `HTTP error! Status: ${response.status}`);
        });
      }
      return response.json();
    })
    .then(data => {
      // Check for success indicator in the response
      if (data && (data.success === true || data.status === 'success')) {
        console.log('Survey submitted successfully:', data);
        // Extract discount code if available
        const discountCode = data.discount || null;
        this.showThankYouMessage(discountCode);
      } else {
        console.warn('Unexpected API success response format:', data);
        // Show thank you message anyway if we got this far
        this.showThankYouMessage();
      }
    })
    .catch(error => {
      console.error('Error submitting survey:', error);
      this.showErrorMessage('There was an error submitting your survey. Please try again later.');
    });
  }

  showThankYouMessage(discountCode = null) {
    const modalBody = this.modal.querySelector('.survey-modal-body');
    
    // Create different HTML based on whether we have a discount code
    let discountHtml = '';
    if (discountCode) {
      discountHtml = `
        <div class="discount-code-container">
          <h4>Your Discount Code</h4>
          <div class="discount-code">${discountCode}</div>
          <p class="discount-expiry">This code is valid for 24 hours only!</p>
        </div>
      `;
    }
    
    modalBody.innerHTML = `
      <div class="survey-thank-you">
        <h3>Thank You for Your Feedback!</h3>
        <p>We appreciate you taking the time to share your thoughts with us. Your feedback helps us improve our service.</p>
        ${discountHtml}
        <button class="survey-close-thank-you">Close</button>
      </div>
    `;
    
    // Add event listener to close button
    modalBody.querySelector('.survey-close-thank-you').addEventListener('click', () => {
      this.closeModal();
    });
  }
  
  showErrorMessage(message) {
    // Create error message container if it doesn't exist
    let errorContainer = this.modal.querySelector('.survey-error-message');
    
    if (!errorContainer) {
      errorContainer = document.createElement('div');
      errorContainer.className = 'survey-error-message';
      const form = this.modal.querySelector('#customer-survey-form');
      form.insertBefore(errorContainer, form.querySelector('.survey-submit'));
    }
    
    // Set the error message
    errorContainer.innerHTML = `
      <div class="error-icon"><i class="fa fa-exclamation-circle"></i></div>
      <div class="error-text">${message}</div>
    `;
    
    // Scroll to the error message
    errorContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
    
    // Remove the error message after 5 seconds
    setTimeout(() => {
      if (errorContainer && errorContainer.parentNode) {
        errorContainer.parentNode.removeChild(errorContainer);
      }
    }, 5000);
  }
}

// Initialize the customer survey when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new CustomerSurvey();
});
